import { Injectable, OnInit } from '@angular/core';
import { AppInsights } from 'applicationinsights-js'; 
import { ConfigService } from './config.service';
import { MsalService } from './msal.service';

@Injectable()
export class MonitoringService {
    // Based on: https://blogs.msdn.microsoft.com/premier_developer/2017/05/11/add-application-insights-to-an-angular-spa/
     private config: Microsoft.ApplicationInsights.IConfig;

    constructor(configService: ConfigService,
                private msalService: MsalService) {
        this.config = {
            instrumentationKey: configService.config.applicationInsightsInstrumentationKey
        };
        if (!AppInsights.config && AppInsights.downloadAndSetup) {
            AppInsights.downloadAndSetup(this.config);
        }

        if (this.msalService.authenticated) {
            AppInsights.setAuthenticatedUserContext(this.msalService.userid);
        }
    }

	logPageView(name?: string, url?: string, properties?: any, 
			measurements?: any, duration?: number) { 
	    AppInsights.trackPageView(name, url, properties, measurements, duration); 
	} 

	logEvent(name: string, properties?: any, measurements?: any) { 
		AppInsights.trackEvent(name, properties, measurements); 
	}
} 


// WEBPACK FOOTER //
// ./ClientApp/app/_shared/services/monitoring.service.ts